export function syncDoctorNameByDoctorId({ doctorId, currentDoctor, setFamilyName, setFirstName }) {
  if (!currentDoctor) return;

  if (doctorId != null) {
    setFamilyName(currentDoctor.familyName || "");
    setFirstName(currentDoctor.firstName || "");
  } else {
    setFamilyName("");
    setFirstName("");
  }
}
